<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.history') }}</span>
    </div>
    <div class="page-card-content pt-20">
      <div class="page-content">
        <ReportHistoryTable />
      </div>
    </div>
  </div>
</template>

<script>
import ReportHistoryTable from '@/components/manage/patients/ReportHistoryTable.vue'
export default {
  components: {
    ReportHistoryTable
  }
}
</script>
